import { makeServicesTypesFromEnum } from '@/core/container/makeServicesTypes'

export enum TASKS_SERVICES {
  KanbanService,
  TaskService,
  TaskStageService,
  TaskRepository,
  TaskStageRepository,
  TaskBoardStagesPreloaderService,
  TaskBoardResolver,
  TaskBoardViewSwitcherService,
  TaskListWebsocketService,
  TasksColumnService,
  TasksFilterServiceFactory,
  TasksGridableService,
  TasksKanbanGridableService,
  ContactTasksGridableService,
  TaskSettingsResolver,
  TaskRedirectToFirstBoardResolver,
  TaskBoardFormService,
  TaskStageFormService,
  TaskEditStageFormService,
  CreateTaskFormService,
  FastCreateTaskFormService,
  TaskViewFormService,
  TaskMoveAllFormService,
  TaskStageDeleteFormService,
  TaskBoardPreloaderService,
  TaskChecklistRepository,
  TaskChecklistService,
  TaskChecklistItemRepository,
  TaskChecklistItemService,
  TaskChecklistItemFormService,
  TaskChecklistFormService,
  TaskViewModalResolverService,
  TaskCommentRepository,
  TaskCommentService,
  TaskCommentFormService,
  TaskBoardArchivedService,
  TaskBoardArchivedRepository,
  TaskBoardArchivatorService,
  TaskBoardsArchivedPreloaderService,
  TaskBoardArchivedSinglePreloaderService,
  TaskCommentSubscriptionResolverService,
  TaskChecklistResolverService,
  TaskAttachmentsFormService,
  TaskAttachmentsService,
}

export type TasksServices = keyof typeof TASKS_SERVICES

export const TASKS_SERVICES_TYPES = makeServicesTypesFromEnum<TasksServices>(TASKS_SERVICES)
